export default __webpack_public_path__ + "static/media/photo-notification.74c2bd50.png";